import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class WidgetCustom extends BaseAPIModel {
    fields() {
        return {
            uuid: { primaryKey: true }
        };
    }

    static list(item) {
        return item;
    }

    static getItemUrl(...args) {
        return this.listUrl(...args);
    }

    static listUrl({ organizationId, widgetId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][WidgetCustom][getAll] organizationId is mandatory`);
        }

        if (!widgetId) {
            return `/ticket/organizations/${organizationId}/widgets/customs`;
        }

        return `/ticket/organizations/${organizationId}/widgets/${widgetId}/customs`;
    }
}
